import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=b05740a8&scoped=true"
import script from "./content-item.vue?vue&type=script&lang=js"
export * from "./content-item.vue?vue&type=script&lang=js"
import style0 from "./content-item.vue?vue&type=style&index=0&id=b05740a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05740a8",
  null
  
)

export default component.exports